import React, { useState } from "react";
import { BookMarked } from "lucide-react";
import { api } from "@/lib/api";

const FIELDS = [
  ["agreements", "What you've actually agreed", "Only things you have both said out loud or in writing — e.g. “we text if running late”, “Sundays are his family day”. Hopes you haven't discussed belong in Ask, not here."],
  ["recurring_patterns", "Patterns you keep noticing", "How disagreements tend to go, from your side — e.g. “he goes quiet for a day, I chase, then it blows up”."],
  ["what_has_helped", "What has helped before", "Repairs or approaches that worked, in your experience — e.g. “a short voice note the next morning”, “naming it in person, not over text”."],
];

/* Per-persona context memory (bg-1.0): optional, editable, user-reported. Stops Ask re-asking what she already knows. */
export function ProfileContextMemory({ profile, onSaved }) {
  const init = Object.fromEntries(FIELDS.map(([k]) => [k, profile[k] || ""]));
  const [form, setForm] = useState(init);
  const [state, setState] = useState("");
  const dirty = FIELDS.some(([k]) => (form[k] || "") !== (profile[k] || ""));
  const save = async () => {
    setState("saving");
    try { const r = await api.put(`/profiles/${profile.id}`, form); onSaved(r.data); setState("saved"); setTimeout(() => setState(""), 1800); }
    catch { setState("error"); }
  };
  return (
    <div className="mt-6 ss-card p-5" data-testid="profile-context-memory">
      <p className="text-[11px] tracking-[0.4em] uppercase text-mauve inline-flex items-center gap-1.5"><BookMarked size={12} /> Context you'd rather not repeat</p>
      <p className="mt-1 text-xs text-cocoa/55">Optional. SugarSense treats these as your account of things — never as the other person's confirmation — and uses them so Ask doesn't keep asking what you already know. Edit or clear any time.</p>
      <div className="mt-4 grid md:grid-cols-3 gap-4">
        {FIELDS.map(([k, label, hint]) => (
          <label key={k} className="block">
            <span className="text-[10px] uppercase tracking-widest text-cocoa/55">{label}</span>
            <textarea data-testid={`profile-ctx-${k}`} rows={4} maxLength={1500} value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })}
              placeholder={hint} className="mt-1 w-full bg-ivory border border-champagne rounded-md p-3 text-sm text-cocoa outline-none focus:border-mauve placeholder:text-cocoa/35" />
          </label>
        ))}
      </div>
      <div className="mt-3 flex items-center gap-3">
        <button data-testid="profile-ctx-save" onClick={save} disabled={!dirty || state === "saving"} className="ss-pill ss-pill-primary h-10 disabled:opacity-40">{state === "saving" ? "Saving…" : "Save context"}</button>
        {state === "saved" && <span className="text-xs text-sage" data-testid="profile-ctx-saved">Saved</span>}
        {state === "error" && <span className="text-xs text-rose" data-testid="profile-ctx-error">Couldn't save — try again</span>}
      </div>
    </div>
  );
}
